module.exports = __webpack_public_path__ + "img/sets-bundle.93294a82.svg";